<template>
    <div class="flex items-center justify-end gap-2">
        <div v-if="deleteConfirmationVisible" class="flex">
            <UButton
                data-cy="confirm-delete-button"
                color="error"
                size="sm"
                @click.stop="deleteChosenDocument"
            >
                Slett?
            </UButton>
            <UButton
                icon="i-ph-x"
                variant="ghost"
                size="sm"
                color="neutral"
                @click.stop="deleteConfirmationVisible = false"
            />
        </div>

        <div v-else class="flex">
            <UButton
                icon="i-ph-check"
                variant="ghost"
                size="sm"
                color="success"
                title="Godkjenn"
                @click="approveDocument()"
            />
            <UButton
                icon="i-ph-download-simple"
                variant="ghost"
                size="sm"
                color="neutral"
                title="Last ned"
                @click="storageDownloadFile(document.documentMeta)"
            />
            <UButton
                icon="i-ph-trash-fill"
                variant="ghost"
                size="sm"
                color="neutral"
                title="Slett"
                data-cy="delete-document-button"
                @click="deleteConfirmationVisible = true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {approveIncomingDocument, documentMetaDelete, storageDownloadFile} from '@/services/document.service'
import emitter from '@/services/infrastructure/emitter'
import {IncomingDocument} from '@/types/IncomingDocument'
import {LIST_DOCUMENTS} from '@/task-manager/task.events'

const deleteConfirmationVisible = ref(false)

const props = defineProps({
    params: {
        type: Object as () => {
            data: IncomingDocument,
        },
        required: true
    }
})

const document = computed(() => {
    return props.params.data
})

const deleteChosenDocument = async () => {
    await documentMetaDelete(document.value.documentMeta.uuid)
    emitter.emit(LIST_DOCUMENTS)
    deleteConfirmationVisible.value = false
}

const approveDocument = async () => {
    await approveIncomingDocument(document.value.documentMeta.uuid)
    emitter.emit(LIST_DOCUMENTS)
}


</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";


</style>